<template>
    <v-overlay v-if="!! value">
        <div @click="closeOverlay" class="d-flex tw-fixed tw-inset-0 justify-center align-center">
            <youtube :video-id="value"></youtube>

            <v-btn @click="closeOverlay" large icon fixed top right>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
    </v-overlay>
</template>

<script>
export default {
    props: [ 'value' ],

    methods: {
        closeOverlay() {
            this.$emit('input', false)
        }
    }
}
</script>
